<template>
  <div>
    <div @click="seeOther" :class="['other-options']">
      <div class="banner-desc">
        <h3 v-if="formItem.title">{{ formItem.title }}</h3>
        <p v-if="formItem.sub_title">{{ formItem.sub_title }}</p>
      </div>
      <span :class="['unOpen', { opened: isOpened }]"></span>
    </div>
    <div class="option-container" v-show="isOpened">
        <div class="option" v-for="(item, idx) in formItem.options" :key="idx">
            <radio-card
                :form-item="item || {}"
                :choosed-key="choosedKey"
                @choose="chooseWork"></radio-card>
        </div>
    </div>
  </div>
</template>
<script>
import RadioCard from "./radioCard.vue";

export default {
  name: "typeCard",
  props: ["formItem", "choosedKey", "omegaItem"],
  data() {
    return {
      isOpened: false,
    };
  },
  mounted() {
    this.isOpened = this.formItem.is_expand
  },
  components: {
    RadioCard,
  },
  computed: {
    // isChecked() {
    //   return this.choosedKey === this.formItem.key;
    // },
  },
  methods: {
    seeOther() {
      try {
        Omega.trackEvent("ibt_gd_selection_other_btn_ck", "", {
          ...this.omegaItem,
        });
      } catch (error) {}
      this.isOpened = !this.isOpened;
    },
    chooseWork(item) {
      this.$emit("choose", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.other-options {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0.4rem 0 0.2rem 0;
  padding: 0 0.32rem;
  min-height: 0.84rem;
  .banner-desc > h3 {
    font-size: 0.36rem;
    color: #333333;
    line-height: 0.42rem;
    font-weight: 500;
  }
  .banner-desc > p {
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.42rem;
    font-weight: 400;
  }
  .unOpen {
    position: absolute;
    top: 50%;
    right: 0.32rem;
    width: 0.48rem;
    height: 0.48rem;
    background: url("../../images/arrow_show_hide.png") no-repeat;
    background-size: 100%;
    transform: translateY(-50%);
  }
  .opened {
    transform: translateY(-50%) rotate(180deg);
  }
}
</style>


